
import { TableHead, TableHeader, TableRow } from "@/components/ui/table";

export const StaffTableHeader = () => {
  return (
    <TableHeader>
      <TableRow>
        <TableHead>Email</TableHead>
        <TableHead>Mobile Number</TableHead>
        <TableHead>School ID</TableHead>
        <TableHead>Actions</TableHead>
      </TableRow>
    </TableHeader>
  );
};
